import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SortDescendingSVG = function SortDescendingSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M3 11h14a1 1 0 000-2H3a1 1 0 000 2zM11 15H3a1 1 0 000 2h8a1 1 0 000-2zM7 21H3a1 1 0 000 2h4a1 1 0 000-2zM29.7 21.2a1 1 0 00-1.5 0L23 26.5V3a1 1 0 10-2 0v23.5l-5.2-5.3a1 1 0 00-1.5 0 1 1 0 000 1.5l6.9 7a1 1 0 00.8.3 1.1 1.1 0 00.8-.3l6.9-7a1 1 0 000-1.5z"
  }));
};
SortDescendingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SortDescendingSVG);